var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFontDecrease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.345 6.934a.93.93 0 0 1-.678-.27.895.895 0 0 1-.274-.664c0-.263.092-.485.274-.664a.93.93 0 0 1 .678-.27h5.203a.93.93 0 0 1 .677.27c.183.18.275.4.275.664a.894.894 0 0 1-.275.664.93.93 0 0 1-.677.27h-5.203zM3.433 9.013l-.853 2.304a1.026 1.026 0 0 1-.985.683c-.376 0-.674-.155-.893-.466a.992.992 0 0 1-.123-.99L4.438.7c.083-.217.22-.388.41-.512.19-.125.398-.187.623-.187h.88c.235 0 .446.063.633.19.187.126.321.297.405.514l3.833 9.846a.985.985 0 0 1-.125.99c-.221.306-.522.46-.902.46-.235 0-.45-.065-.643-.195a1.069 1.069 0 0 1-.416-.53L8.32 9.013H3.433zM4.087 7.2h3.58L5.927 2.357h-.087L4.087 7.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFontDecrease);
export default __webpack_public_path__ + "static/media/font-decrease.421d02879fb8c07c9ae30212df14461f.svg";
export { ForwardRef as ReactComponent };